import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/(app)/store-information/basic-stores/switch-store')({
  component: RouteComponent,
});

function RouteComponent() {
  return <Outlet />;
}
